//#region src/extensions/image-extension/image-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.Inline = "inline-image", e.Block = "block-image", e;
}({}), t = /* @__PURE__ */ function(e) {
	return e.Inline = "inline", e.BlockCenter = "blockCenter", e.BlockRight = "blockRight", e;
}({}), n = /* @__PURE__ */ function(e) {
	return e.Before = "before", e.After = "after", e;
}({}), r = /* @__PURE__ */ function(e) {
	return e[e.InitialMode = 0] = "InitialMode", e[e.ViewLinkMode = 1] = "ViewLinkMode", e.EditCaptionMode = "caption", e.EditAltMode = "alt", e.EditLinkMode = "href", e;
}({});
//#endregion
export { r as ImageBubbleMenuState, t as ImageModeEnum, e as ImageNameEnum, n as InsertParagraphEnum };
